import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const editUserConfigsSlice = createSlice({
  name: 'editUserConfigs',
  initialState,
  reducers: {
    editUserConfigsRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    editUserConfigsSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    editUserConfigsFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    editUserConfigsReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const editUserConfigsAction = editUserConfigsSlice.actions;
export default editUserConfigsSlice;